import { createStore } from 'vuex';
import NProgress from 'nprogress'//引入nprogress
import {storage} from '../utils/utils'

export default createStore({
    //存储数据
    state: {
		token: storage.get('token') ? storage.get('token') : '',
		userInfo: storage.get('userInfo') ? storage.get('userInfo') : null,
        showAside: storage.get('showAside') ? storage.get('showAside') : true, //是否显示左侧栏
        currentMenu: null,
        tabsList: [
            {
                path: '/',
                name: 'home',
                label: '首页',
                icon: 'home'
            }
        ],
        breadList: []
    },
	getters: {
		isLogin(state){
			return !!state.token
		},
        isUpdate(state){
            if(state.userInfo)
                return state.userInfo.authoritys.split(',').indexOf('2') > -1
            else
                return false
        },
        isDelete(state){
            if(state.userInfo)
                return state.userInfo.authoritys.split(',').indexOf('3') > -1
            else
                return false
        },
        isAdmin(state){
            if(state.userInfo)
                return state.userInfo.id === 1
            else
                return false
        }
    },
    //调用方法
    mutations: {
        // collapseMenu(state) {
        //     state.isCollapse = !state.isCollapse
        // },
        //选择标签 选择面包屑
        selectMenu(state, val) {
            if (val.name === 'home') {
                state.currentMenu = null
            }
            else{
                // console.log(val.name)
                let tabs = []
                state.tabsList.forEach((c)=>{
                    tabs.push(c.name)
                })
                if(tabs.indexOf(val.name) === -1){
                    NProgress.start()
                }
                state.currentMenu = val
                //如果等于-1说明tabsList不存在那么插入，否则什么都不做
                let result = state.tabsList.findIndex(item => item.name === val.name)
                result === -1 ? state.tabsList.push(val) : ''
            }
            // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
        },
        //关闭标签
        closeTab(state, val) {
            let result = state.tabsList.findIndex(item => item.name === val.name)
            state.tabsList.splice(result, 1)
        },
        setBreadList(state, list){
            state.breadList = list
        },
		SET_ASIDE(state, val){			
			state.showAside = val
			storage.set('showAside', state.showAside)
		},
        
		SET_TOKEN(state, data){
            // console.log(data)
			if(data.token){
				state.token = data.token
				storage.set('token', state.token)
			}
			if(data.userInfo){
				state.userInfo = data.userInfo
				storage.set('userInfo', state.userInfo)
			}
		},
		SET_USERINFO(state, data){
			if(data.id === state.userInfo.id){
				state.userInfo = data
				storage.set('userInfo', state.userInfo)
			}
		},
		EXIT(state){
			state.token = ''
			state.userInfo = null
			storage.remove('token')
			storage.remove('userInfo')
		},
    },
    actions: {}

})